import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
export type ProjectReportDataFieldsFragment = { readonly __typename?: 'ProjectReportData', readonly meta: { readonly __typename?: 'ProjectReportMeta', readonly adSystem: Types.OauthProvider, readonly periodStart: string, readonly periodEnd: string }, readonly project: { readonly __typename?: 'ProjectReportProject', readonly name?: string | null, readonly narrativeFailed?: boolean | null, readonly score?: number | null, readonly scoreZone?: Types.ProjectReportScoreZoneKey | null, readonly spend?: string | number | null, readonly risk?: string | number | null, readonly riskDailySpend?: string | number | null, readonly riskPct?: number | null, readonly riskNote?: string | null, readonly sensorWarning?: string | null, readonly scoreZones?: ReadonlyArray<{ readonly __typename?: 'ProjectReportScoreZone', readonly key: Types.ProjectReportScoreZoneKey, readonly from: number, readonly to: number }> | null, readonly scoreParts?: ReadonlyArray<{ readonly __typename?: 'ProjectReportScorePart', readonly key: Types.ProjectReportScorePartKey, readonly got: number, readonly max: number, readonly note?: string | null }> | null, readonly summary?: ReadonlyArray<{ readonly __typename?: 'ProjectReportSummaryPoint', readonly severity: Types.ProjectReportSeverity, readonly detail: string, readonly anchor: Types.ProjectReportSection, readonly title: ReadonlyArray<{ readonly __typename?: 'ProjectReportTextSegment', readonly text: string, readonly emphasis: boolean }> }> | null, readonly kpi?: { readonly __typename?: 'ProjectReportKpi', readonly name: Types.ProjectReportKpiName, readonly plan?: string | number | null, readonly fact?: string | number | null, readonly deviationPct?: number | null, readonly status: Types.ProjectReportKpiStatus } | null, readonly clients?: { readonly __typename?: 'ProjectReportClients', readonly budget: string | number, readonly cplPlan?: string | number | null, readonly cplFact?: string | number | null, readonly leadsPlan?: number | null, readonly leadsFact: number, readonly gap?: number | null, readonly planSource: Types.ProjectReportPlanSource } | null, readonly risks?: ReadonlyArray<{ readonly __typename?: 'ProjectReportRiskRow', readonly campaignId: string, readonly name?: string | null, readonly spend?: string | number | null, readonly criticalFound: number, readonly simple?: string | null, readonly professional?: string | null, readonly sensors?: ReadonlyArray<{ readonly __typename?: 'ProjectReportRiskSensor', readonly key: string, readonly name: string, readonly found: number }> | null }> | null, readonly riskRest?: ReadonlyArray<{ readonly __typename?: 'ProjectReportRiskRestRow', readonly campaignId: string, readonly name?: string | null, readonly spend?: string | number | null }> | null, readonly zeroResult?: { readonly __typename?: 'ProjectReportWaste', readonly spend?: string | number | null, readonly pct?: number | null, readonly campaigns?: ReadonlyArray<{ readonly __typename?: 'ProjectReportWasteCampaign', readonly campaignId: string, readonly name?: string | null, readonly spend?: string | number | null, readonly clicks?: number | null, readonly kpiFact?: string | number | null }> | null } | null, readonly edits?: { readonly __typename?: 'ProjectReportEdits', readonly total?: number | null, readonly point?: number | null, readonly mass?: number | null, readonly daysWithEdits?: number | null, readonly manualDays?: number | null, readonly conclusion?: string | null, readonly calendar?: ReadonlyArray<{ readonly __typename?: 'ProjectReportEditDay', readonly date: string, readonly count: number, readonly kind: Types.ProjectReportEditKind }> | null, readonly pauses?: ReadonlyArray<{ readonly __typename?: 'ProjectReportPause', readonly from: string, readonly to: string, readonly days: number, readonly overIncident: boolean }> | null } | null, readonly editsStatus?: { readonly __typename?: 'ProjectReportEditsStatus', readonly status: Types.ProjectReportSectionStatus, readonly reason?: Types.ProjectReportEditsStatusReason | null } | null, readonly incidents?: { readonly __typename?: 'ProjectReportIncidents', readonly baselineFound: number, readonly baselineFixed: number, readonly totalFound: number, readonly totalFixed: number, readonly cumulative: ReadonlyArray<{ readonly __typename?: 'ProjectReportIncidentPoint', readonly date: string, readonly found: number, readonly fixed: number }> } | null, readonly questions?: ReadonlyArray<{ readonly __typename?: 'ProjectReportQuestion', readonly question: string, readonly basis?: string | null, readonly answers?: ReadonlyArray<{ readonly __typename?: 'ProjectReportAnswerExample', readonly quality: Types.ProjectReportAnswerQuality, readonly text: string, readonly why: string }> | null }> | null, readonly tasks?: ReadonlyArray<{ readonly __typename?: 'ProjectReportTask', readonly priority: Types.ProjectReportTaskPriority, readonly title: string, readonly description: string, readonly campaigns?: ReadonlyArray<{ readonly __typename?: 'ProjectReportTaskCampaign', readonly campaignId: string, readonly name?: string | null }> | null }> | null, readonly control?: { readonly __typename?: 'ProjectReportControl', readonly nextReportDate: string, readonly expectations: ReadonlyArray<{ readonly __typename?: 'ProjectReportExpectation', readonly metric: Types.ProjectReportExpectationMetric, readonly note?: string | null, readonly from: { readonly __typename?: 'ProjectReportTarget', readonly bound?: Types.ProjectReportBound | null, readonly text?: string | null, readonly amount?: { readonly __typename?: 'ProjectReportAmount', readonly value: string | number, readonly unit: Types.ProjectReportUnit, readonly of?: string | number | null } | null }, readonly to: { readonly __typename?: 'ProjectReportTarget', readonly bound?: Types.ProjectReportBound | null, readonly text?: string | null, readonly amount?: { readonly __typename?: 'ProjectReportAmount', readonly value: string | number, readonly unit: Types.ProjectReportUnit, readonly of?: string | number | null } | null } }> } | null } };

export const FragmentProjectReportDataFieldsFragmentDoc = gql`
    fragment ProjectReportDataFields on ProjectReportData {
  meta {
    adSystem
    periodStart
    periodEnd
  }
  project {
    name
    narrativeFailed
    score
    scoreZone
    scoreZones {
      key
      from
      to
    }
    scoreParts {
      key
      got
      max
      note
    }
    summary {
      severity
      detail
      anchor
      title {
        text
        emphasis
      }
    }
    kpi {
      name
      plan
      fact
      deviationPct
      status
    }
    clients {
      budget
      cplPlan
      cplFact
      leadsPlan
      leadsFact
      gap
      planSource
    }
    spend
    risk
    riskDailySpend
    riskPct
    riskNote
    sensorWarning
    risks {
      campaignId
      name
      spend
      criticalFound
      sensors {
        key
        name
        found
      }
      simple
      professional
    }
    riskRest {
      campaignId
      name
      spend
    }
    zeroResult {
      spend
      pct
      campaigns {
        campaignId
        name
        spend
        clicks
        kpiFact
      }
    }
    edits {
      total
      point
      mass
      daysWithEdits
      manualDays
      conclusion
      calendar {
        date
        count
        kind
      }
      pauses {
        from
        to
        days
        overIncident
      }
    }
    editsStatus {
      status
      reason
    }
    incidents {
      baselineFound
      baselineFixed
      totalFound
      totalFixed
      cumulative {
        date
        found
        fixed
      }
    }
    questions {
      question
      basis
      answers {
        quality
        text
        why
      }
    }
    tasks {
      priority
      title
      description
      campaigns {
        campaignId
        name
      }
    }
    control {
      nextReportDate
      expectations {
        metric
        note
        from {
          bound
          text
          amount {
            value
            unit
            of
          }
        }
        to {
          bound
          text
          amount {
            value
            unit
            of
          }
        }
      }
    }
  }
}
    `;